import { useCallback } from "react";
import { MutationResult, OperationVariables } from "@apollo/client";
import { MutationHookOptions } from "@apollo/client/react/types/types";
import { FetchResult } from "@apollo/client/link/core";
import { CREATE_MATTER_TEMPLATE } from "../../graphql/mutation/create-matter-template";
import {
  createMatterTemplate,
  createMatterTemplateVariables,
} from "../../graphql/__generated_types__/createMatterTemplate";
import { useMutation } from "../use-mutation";
import { MatterCreateInput } from "../../graphql/__generated_types__/globalTypes";
import { MATTER_TEMPLATE_LIST_ITEMS_QUERY } from "../../graphql/query";

export type CreateMatterTemplateFunction = (
  data: MatterCreateInput,
  cloneTemplateId?: number
) => Promise<FetchResult<createMatterTemplate>>;

export function useCreateMatterTemplateMutation(
  refetchVariables: OperationVariables,
  options?: MutationHookOptions<createMatterTemplate, createMatterTemplateVariables>
): [CreateMatterTemplateFunction, MutationResult<createMatterTemplate>] {
  const [createMatterTemplate, result] = useMutation<
    createMatterTemplate,
    createMatterTemplateVariables
  >(CREATE_MATTER_TEMPLATE, options);
  const callback = useCallback<CreateMatterTemplateFunction>(
    (data, cloneTemplateId) =>
      createMatterTemplate({
        variables: { data, cloneTemplateId },
        refetchQueries: [
          {
            query: MATTER_TEMPLATE_LIST_ITEMS_QUERY,
            variables: refetchVariables,
          },
        ],
        // update: (cache, { data }) => {
        //   cache.updateQuery<FindMatterTemplateListItems, FindMatterTemplateListItemsVariables>(
        //     {
        //       query: MATTER_TEMPLATE_LIST_ITEMS_QUERY,
        //     },
        //     (prev) => {
        //       if (prev && data) {
        //         return {
        //           ...prev,
        //           matterTemplates: {
        //             ...prev.matterTemplates,
        //             items: [data.createMatterTemplate, ...prev.matterTemplates.items],
        //           },
        //         };
        //       }
        //       return prev;
        //     }
        //   );
        // },
      }),
    [createMatterTemplate]
  );
  return [callback, result];
}

// FindMatterTemplateListItems,
//     FindMatterTemplateListItemsVariables
//   >(MATTER_TEMPLATE_LIST_ITEMS_QUERY
